import { Button, Space, Tag, Typography } from "antd";
import { useT } from "../i18n/context";
import type { MemoryConfirmation as MemoryConfirmationType } from "../types";

const { Text } = Typography;

interface MemoryConfirmationProps {
  confirmations: MemoryConfirmationType[];
  onApprove: (toolUseId: string) => void;
  onDeny: (toolUseId: string) => void;
}

export default function MemoryConfirmation({
  confirmations,
  onApprove,
  onDeny,
}: MemoryConfirmationProps) {
  const t = useT();
  if (confirmations.length === 0) return null;

  return (
    <div
      style={{
        position: "absolute",
        top: 56,
        right: 16,
        zIndex: 1001,
        background: "var(--lude-im-bg-elevated)",
        border: "1px solid var(--lude-im-border)",
        borderRadius: "var(--lude-im-radius-card)",
        padding: 12,
        width: 340,
        maxHeight: 300,
        overflow: "auto",
        boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
      }}
    >
      <Text strong style={{ fontSize: 13, marginBottom: 8, display: "block" }}>
        {t("memory.title")} ({confirmations.length})
      </Text>
      {confirmations.map((mc) => {
        const inp = mc.input as Record<string, unknown>;
        const summary =
          mc.action === "save"
            ? (inp.content as string | undefined) ?? JSON.stringify(inp)
            : (inp.key as string | undefined) ?? JSON.stringify(inp);
        return (
          <div
            key={mc.toolUseId}
            style={{
              marginBottom: 8,
              padding: 8,
              background: "var(--lude-im-bg-primary)",
              borderRadius: "var(--lude-im-radius-sm)",
            }}
          >
            <Tag color={mc.action === "save" ? "green" : "red"} style={{ marginBottom: 4 }}>
              {mc.action === "save" ? t("memory.save") : t("memory.delete")}
            </Tag>
            <div
              style={{
                fontSize: 12,
                maxHeight: 80,
                overflow: "auto",
                marginBottom: 6,
                opacity: 0.8,
              }}
            >
              {summary}
            </div>
            <Space size={4}>
              <Button size="small" danger onClick={() => onDeny(mc.toolUseId)}>
                {t("tool.deny")}
              </Button>
              <Button size="small" type="primary" onClick={() => onApprove(mc.toolUseId)}>
                {t("tool.approve")}
              </Button>
            </Space>
          </div>
        );
      })}
    </div>
  );
}
